<div class="container-fluid mt-2 pb-5">

    <toolbar [actions]="actionsToolbar" [titulo]="titulo" [mode]="'dark'"></toolbar>

    <loader-page [show]="loading"></loader-page>

    <ng-container *ngFor="let grupo of grupos; let isLast = last; let i = index">

        <div class="carousel-wrapper">
            <button *ngIf="podeScrollarEsquerda[i]" class="arrow arrow-left" (click)="scrollLeft(i)"
                aria-label="Anterior">&#10094;</button>

            <div class="grupo mt-5" #grupoContainer (scroll)="onScroll($event, i)">
                <ng-container *ngFor="let licencaMaterial of grupo.licencasMateriais">
                    <div class="card-item">
                        <card-licenca [licenca]="licencaMaterial.licenca"></card-licenca>
                    </div>
                    <div *ngFor="let material of licencaMaterial.materiais" class="card-item">
                        <card-material *ngIf="urlCapaMaterial" [material]="material" [licenca]="licencaMaterial.licenca"
                            [urlCapa]="urlCapaMaterial"></card-material>
                    </div>
                    <div *ngIf="grupo.checkoutUrl" class="card-item">
                        <card-checkout-green [checkoutUrl]="grupo.checkoutUrl"
                            [metadadosGreen]="metadadosGreen"></card-checkout-green>
                    </div>
                </ng-container>
                <ng-container *ngIf="grupo.licencasMateriais.length > 1">
                    <div class="card-item">
                        <card-comparativo [grupo]="grupo"></card-comparativo>
                    </div>
                </ng-container>
                <br>
            </div>

            <button *ngIf="podeScrollarDireita[i]" class="arrow arrow-right" (click)="scrollRight(i)"
                aria-label="Próximo">&#10095;</button>
        </div>

    </ng-container>
</div>
